export async function productThumbnail(product, maxDimension = 240) {
  const images = Array.isArray(product?.images) ? product.images : [];
  const url = images[product?.main_image_index || 0] || images[0];
  if (!url) return null;
  const response = await fetch(url);
  if (!response.ok) throw new Error("No se pudo cargar la imagen del artículo.");
  const bitmap = await window.createImageBitmap(await response.blob());
  try {
    const scale = Math.min(1, maxDimension / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(bitmap.width * scale));
    canvas.height = Math.max(1, Math.round(bitmap.height * scale));
    canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
    if (!blob) throw new Error("No se pudo preparar la miniatura del artículo.");
    return new Uint8Array(await blob.arrayBuffer());
  } finally { bitmap.close(); }
}

export async function printCostSheetCompact(model) {
  const { buildCostSheetPdf } = await import("./manufacturingDocuments.js");
  const thumbnail = await productThumbnail(model.product);
  const pdf = await buildCostSheetPdf({ ...model, thumbnail });
  return URL.createObjectURL(new Blob([await pdf.save()], { type: "application/pdf" }));
}
